export default __webpack_public_path__ + "static/media/31.5510ec09.jpeg";